<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title> Student Fees Structure </v-toolbar-title>
            </v-toolbar>
            <br />
            <v-row>
                <v-col cols="12" sm="2" md="2"></v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete rounded :items="academic_year_list" v-model="selected_ay" item-text="academicyear"
                        item-value="ay_id" label="Academic Year" dense outlined placeholder="Select Academic Year"
                        :loading="comp_load" @change="celareSelection()"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="5" md="5">
                    <v-autocomplete rounded :items="stud_list" v-model="stud_data" item-text="name"
                        label="Search Student" dense return-object outlined :loading="comp_load" @change="getData"
                        placeholder="Search by PRN No or name"></v-autocomplete>
                </v-col>
            </v-row>
            <v-card class="box" v-if="basic_student_data != null">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title> Student Details </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12">
                    <v-row justify="center" dense>
                        <v-col cols="12" sm="6" md="6"><strong>Name : </strong>{{ basic_student_data.registration_number
                            }} : {{ basic_student_data.student_name }}</v-col>
                        <v-col cols="12" sm="6" md="6"><strong>Admission Year : </strong>{{
                            basic_student_data.learner_addmission_year }}</v-col>
                    </v-row>
                    <v-row justify="center" dense>
                        <v-col cols="12" sm="3" md="3"><strong>Standard : </strong>{{ basic_student_data.standard
                            }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Division : </strong>{{ basic_student_data.division
                            }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Roll No. : </strong>{{ basic_student_data.roll_no
                            }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Quota : </strong>{{ basic_student_data.quota }}</v-col>
                    </v-row>
                </v-col>
                <v-row justify="center" dense>
                    <v-switch color="#0F2027"
                        @change="saveStudentSyncFee(basic_student_data.ignore_sync_fee,basic_student_data.is_loan_application_enabled)"
                        v-model="basic_student_data.ignore_sync_fee" label="Ignore Student Sync Fee"></v-switch>
                    <v-switch color="#0F2027" v-if="allow_apply_loan == 'YES'" class="pl-5"
                        @change="saveStudentSyncFee(basic_student_data.ignore_sync_fee,basic_student_data.is_loan_application_enabled)"
                        v-model="basic_student_data.is_loan_application_enabled" label="Turn On Loan Application Option"></v-switch>
                </v-row>

            </v-card>
            <v-card class="box" v-if="student_fees_structure.length != 0">
                <v-row justify="center" dense><v-switch color="#0F2027" v-model="edit_paid_till_now"
                        label="Edit Paid Till Now"></v-switch></v-row>
                <v-toolbar dense class="toolbar" flat color="white">
                    <v-toolbar-title> Fees Structure </v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-simple-table class="elevation-1 mytable" dense v-if="student_fees_structure.length > 0"
                        id="mytable1">
                        <template>
                            <thead color="#ffffcc">
                                <tr>
                                    <th class="text-left">Sr. No.</th>
                                    <th class="text-left">Fees Components</th>
                                    <th class="text-left">Amount to be Paid</th>
                                    <th class="text-left">Paid Amount</th>
                                    <th class="text-left">Remaining Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in student_fees_structure" :key="item.component_selection_id">
                                    <td>{{ i + 1 }}</td>
                                    <td>{{ item.component_name }}</td>
                                    <td>
                                        <input type="hidden" name="components_id" value="item.component_selection_id" />
                                        <v-text-field type="number" rounded class="padding-bot ml-2 pt-2" outlined dense
                                            v-model="item.amount_to_be_paid"></v-text-field>
                                    </td>
                                    <td>
                                        <span v-if="edit_paid_till_now">
                                            <v-text-field type="number" rounded class="padding-bot ml-2 pt-2" outlined
                                                dense v-model="item.paid_till_now"></v-text-field>
                                        </span>
                                        <span v-else>
                                            {{ item.paid_till_now }}
                                        </span>
                                        <!-- {{ item.paid_till_now }} -->
                                    </td>
                                    <td>{{ item.amount_to_be_paid - item.paid_till_now }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
                <v-row justify="center">
                    <v-col cols="12" sm="3" md="3">
                        <v-btn class="mb-2 button" :disabled="allow_save_paid_till_now == false" small
                            @click="confirm_dialog = true" :loading="loader">Save</v-btn>
                        <!-- </v-col>
                     <v-col cols="12" sm="3" md="3"> -->
                        <v-btn v-if="edit_paid_till_now" class="mb-2 button"
                            :disabled="allow_save_paid_till_now == false" small
                            @click="confirm_dialog_paid_till_now = true" :loading="loader">Save Paid Till Now</v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-card>
        <v-row justify="center">
            <v-dialog v-model="confirm_dialog" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">
                        Are you sure you want to change Amount?
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="clearAmount()">
                            Disagree
                        </v-btn>
                        <v-btn color="green darken-1" text @click="saveDetails(student_fees_structure)">
                            Agree
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row justify="center">
            <v-dialog v-model="confirm_dialog_paid_till_now" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">
                        Are you sure you want to change Amount?
                    </v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="clearAmount()">
                            Disagree
                        </v-btn>
                        <v-btn color="green darken-1" text @click="savePaidDetails(student_fees_structure)">
                            Agree
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            comp_load: false,
            loader: false,
            confirm_dialog: false,
            confirm_dialog_paid_till_now: false,
            stud_list: null,
            stud_data: null,
            academic_year_list: null,
            selected_ay: null,
            old_ammount: null,
            basic_student_data: null,
            student_fees_structure: [],
            updated_comp_value: [],
            components_value: [],
            components_id: [],
            aws_path: null,
            allow_apply_loan:null,
            // extraBreadcrumbItems: [


            // ],
            breadcrumbClass: "breadcrumb-style1",
            snackbar: false,
            snackbar_msg: "",
            color: "",
            allow_save_paid_till_now: null,
            edit_paid_till_now: false,
        }),
        mounted() {
            this.comp_load = true;
            axios
                .post("/admission/getAllStudents_for_account")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.stud_list = res.data.stud_list;
                        this.academic_year_list = res.data.academic_year_list;
                        this.selected_ay = res.data.current_ay;
                    } else {
                        alert("Somthing went wrong!!!");
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            clearAmount() {
                this.getData();
                this.confirm_dialog = false;
            },
            saveStudentSyncFee(ignore_sync_fee,is_loan_application_enabled){
                if (!confirm("Are you sure you want to modify this ?")) return;
               const formData = {
                    learner_id: this.stud_data.lid,
                    ay_id: this.selected_ay,
                    ignore_sync_fee:ignore_sync_fee,
                    is_loan_application_enabled:is_loan_application_enabled
                };
                axios
                    .post("/AccountingAndFees/saveStudentSyncFee", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.flag == "YES") {
                                this.showSnackbar("#4CAF50", "Save Successfully...");
                            } else if (res.data.flag == "NO") {
                                this.showSnackbar("#b71c1c", res.data.snackbar);
                            }
                        } else {
                            alert("Somthing went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        // alert("Somthing went wrong!!!");
                    })
                    .finally(() => {});
            },
            getData() {
                this.basic_student_data = null;
                this.student_fees_structure = [];
                const formData = {
                    learner_id: this.stud_data.lid,
                    ay_id: this.selected_ay,
                };
                axios
                    .post("/AccountingAndFees/getStudentwiseFeesStructureEditFee", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.flag == "YES") {
                                if (res.data.status == "Yes") {
                                    this.basic_student_data = res.data.basic_student_data;
                                    this.allow_apply_loan = res.data.allow_apply_loan
                                    this.student_fees_structure = res.data.student_fees_structure;
                                    this.save_oldAmount = res.data.student_fees_structure;
                                    this.allow_save_paid_till_now = res.data.allow_save_paid_till_now;
                                    // if (this.student_fees_structure.length == 0) {
                                    //     this.showSnackbar("#b71c1c", "Fees Structure not found!!!");
                                    // }
                                    this.aws_path = res.data.aws_path;
                                } else {
                                    this.showSnackbar("#b71c1c", res.data.status_reasone);
                                }
                            } else if (res.data.flag == "NO") {
                                this.showSnackbar("#b71c1c", res.data.snackbar);
                            }
                        } else {
                            alert("Somthing went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        // alert("Somthing went wrong!!!");
                    })
                    .finally(() => {});
            },
            celareSelection() {
                this.student_fees_structure = [];
                this.basic_student_data = null;
                this.stud_data = null;
            },
            savePaidDetails(student_fees_structure) {
                this.loader = true;
                this.confirm_dialog_paid_till_now = false;
                const formData = {
                    learner_id: this.stud_data.lid,
                    ay_id: this.selected_ay,
                    student_fees_structure: student_fees_structure,
                };
                axios
                    .post("AccountingAndFees/savePaidDetails", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4CAF50", "Paid till now updated successfully...");
                            this.comfirm_btn = true;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reasone);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
            saveDetails(student_fees_structure) {
                this.loader = true;
                this.confirm_dialog = false;
                const formData = {
                    student_fees_structure: student_fees_structure,
                };
                axios
                    .post("AccountingAndFees/saveFeesStructureAmount", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4CAF50", "Ammount updated successfully...");
                            this.comfirm_btn = true;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reasone);
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
        },
    };
</script>
<style scoped>
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }
    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable2 /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
</style>
